import React from 'react'
import styled from 'styled-components'
import { landingPageStore } from 'app/landingPageStore'
import "./landing.css"
import { useSelector, useDispatch } from 'react-redux';
import { setLikeFirstPost, clickGiveButton, rsvpEvent } from 'features/landingPageSlice';

export default function AboutItem(props) {
    const dispatch = useDispatch();
    const { userType } = landingPageStore()
    const { posts, giveBtnClicked, eventRsvped } = useSelector((state) => state.landingPage);

    const handleMouseEnter = () => {
        if(props.itemName === "Posts"){
            if(posts[0].praying){
                return;
            }
            dispatch(setLikeFirstPost());
        }else if(props.itemName === "Giving"){
            if(!giveBtnClicked){
                dispatch(clickGiveButton());
            }
        }else if(props.itemName === "Events"){
            if(!eventRsvped){
                dispatch(rsvpEvent());
            }
        }
    }

    const handleBeginTouch = () => {
        if(props.itemName === "Posts"){
            if(posts[0].praying){
                return;
            }
            dispatch(setLikeFirstPost());
        }else if(props.itemName === "Giving"){
            if(!giveBtnClicked){
                dispatch(clickGiveButton());
            }
        }else if(props.itemName === "Events"){
            if(!eventRsvped){
                dispatch(rsvpEvent());
            }
        }
    }

    return (
        <AboutItemContainer reverse={props.reverseRow}
            onMouseEnter={handleMouseEnter}
            onTouchStart={handleBeginTouch}
            >
            <AboutCenter>
                <EyebrowRow>
                    {props.iconComponent && (
                        <EyebrowIcon>{props.iconComponent}</EyebrowIcon>
                    )}
                    <EyebrowLabel>{props.itemName}</EyebrowLabel>
                </EyebrowRow>
                <Headline>{props.h3Name}</Headline>
                <Body>
                    {userType === 'church' ? props.churchInfo : props.userInfo}
                </Body>
            </AboutCenter>
            <AboutRight backgroundColor={props.backgroundColorImage}>
                <RightExample>
                    {
                        props.divComponent ? (
                            props.divComponent
                        ) : (
                            <ImageWrapper>
                                <img
                                    src={process.env.PUBLIC_URL + props.imagePath}
                                    alt='itm'
                                />
                            </ImageWrapper>
                        )
                    }
                </RightExample>
            </AboutRight>
        </AboutItemContainer>
    )
}

const AboutItemContainer = styled.div`
    width: 100%;
    max-width: 1400px;
    min-height: 520px;
    display: flex;
    flex-direction: ${props => props.reverse ? 'row-reverse' : 'row'};
    justify-content: center;
    align-items: stretch;
    padding: 40px;
    gap: 40px;
    color: white;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;

    @media (max-width: 768px) {
        flex-direction: column;
        padding: 16px;
        gap: 20px;
        min-height: auto;
    }
`

const AboutCenter = styled.div`
    width: 38%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    text-align: left;
    padding: 8px 24px;

    @media (max-width: 768px) {
        width: 100%;
        padding: 8px 4px;
    }
`

const EyebrowRow = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 8px 14px 8px 10px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    background: rgba(255, 255, 255, 0.06);
    backdrop-filter: blur(8px);
    border-radius: 999px;
    margin-bottom: 28px;
`

const EyebrowIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    color: #f5f5f0;
    & > * {
        width: 16px;
        height: 16px;
        font-size: 16px;
    }
    svg { width: 16px; height: 16px; }
`

const EyebrowLabel = styled.span`
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: rgba(245, 245, 240, 0.85);
`

const Headline = styled.h3`
    font-size: clamp(28px, 3vw, 42px);
    font-weight: 700;
    line-height: 1.1;
    letter-spacing: -0.025em;
    color: #ffffff;
    margin: 0;

    @media (max-width: 768px) {
        font-size: 26px;
    }
`

const Body = styled.p`
    font-size: 16px;
    line-height: 1.65;
    font-weight: 400;
    color: rgba(245, 245, 240, 0.72);
    margin: 22px 0 0;
    max-width: 540px;

    @media (max-width: 768px) {
        font-size: 14px;
        margin-top: 16px;
    }
`

const AboutRight = styled.div`
    display: flex;
    flex: 1;
    min-height: 440px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 24px;
    background-color: ${props => props.backgroundColor ? props.backgroundColor : '#80ac33'};
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow:
        0 1px 0 rgba(255, 255, 255, 0.06) inset,
        0 24px 60px rgba(0, 0, 0, 0.28),
        0 2px 6px rgba(0, 0, 0, 0.18);
    overflow: hidden;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: radial-gradient(60% 50% at 50% 0%, rgba(255, 255, 255, 0.08) 0%, transparent 70%);
        pointer-events: none;
    }

    @media (max-width: 768px) {
        width: 100%;
        min-height: 460px;
    }
`

const RightExample = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1;
`

const ImageWrapper = styled.div`
    width: 100%;
    height: 100%;
    padding: 10px;
    border-radius: 20px;
    background-color: white;
    display: flex;
    border: 1px solid rgba(0, 0, 0, 0.08);
    justify-content: center;
    align-items: flex-start;
    img {
        width: 100%;
        height: 100%;
    }
    @media (max-width: 768px) {
        width: 100%;
    }
`
